import React from 'react';
import AMC from '../components/sections/services/AMC';
import SupportTypes from '../components/sections/services/SupportTypes';
import Efficiency from '../components/sections/services/Efficiency';
import FAQ from '../components/sections/services/FAQ';
import ContactCTA from '../components/sections/services/ContactCTA';

const Services = () => {
  return (
    <>
      <SupportTypes />
      <AMC />
      <Efficiency />
      <FAQ />
      <ContactCTA />
    </>
  );
};

export default Services;